import React from 'react'
import { Style } from './style'
import error from '@assets/images/error.svg'

const ModalError = props => {
  const { content, closeModal } = props

  return (
    <Style >
      <div className='block' />
      <div className='modal'>
        <img className='img' src={error} alt={error} />
        <div className='content'>{content}</div>
        <div className='btn-close' onClick={closeModal}>
          Close
        </div>
      </div>
    </Style>
  )
}

export default ModalError